/* global BX */

if (typeof window.B2bCalculationApi === 'undefined') {
    window.B2bCalculationApi = class B2bCalculationApi {
        collect() {
            const fields = document.querySelectorAll('[data-b2b-form] [data-field]');
            const data = {};

            for (const field of fields) {
                if (field.disabled || field.hidden || field.closest('[hidden]')) {
                    continue;
                }
                data[field.dataset.field] = field.value.trim();
            }

            const captchaInput = document.querySelector('[data-b2b-captcha] input[name="smart-token"]');
            data.smart_token = captchaInput ? captchaInput.value : '';

            return data;
        }

        async send(payload) {
            const response = await fetch('/api/v1/form/b2b-calculation', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Session-Id':
                        typeof BX !== 'undefined' && typeof BX.bitrix_sessid === 'function' ? BX.bitrix_sessid() : '',
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();
            if (!response.ok || result.success === false) {
                throw new Error(result.message || 'Ошибка отправки формы');
            }

            return result;
        }
    };
}
